var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPbButtonPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.5 2.5 22.07 30.98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 4.28,
    strokeWidth: 2,
    d: "M25.565 22.45c0-2.857-2.161-5.578-4.46-5.578V7.957a2.245 2.245 0 002.23-2.23 2.244 2.244 0 00-2.23-2.228H9.958a2.244 2.244 0 00-2.23 2.228 2.245 2.245 0 002.23 2.23v8.915c-2.3 0-4.459 2.718-4.459 5.574a1.122 1.122 0 001.115 1.119h7.035l1.325 8.449a.561.561 0 00.557.469h.017a.561.561 0 00.54-.5l.888-8.414h7.474a1.122 1.122 0 001.115-1.119z",
    "data-name": "Path 151"
  })));
}

export default __webpack_public_path__ + "e99fbff20e9e0e5d3089dec0a10e962a.svg";
export { SvgPbButtonPin as ReactComponent };